const initState = {};

const allCartQuote = (state = initState, action) => {
  switch (action.type) {
    case "GET_ALL_CART_OR_QUOTE":
      return { ...action };
    default:
      return { ...state };
  }
};

export { allCartQuote };
